export const TOASTER_CATEGORY = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR"
};

export const ANIMATION = {
  DEFAULT_DELAY_DURATION: 6000
};
